import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';

import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

export interface IUserData {
  name: string;
  email: string;
  regDate: string;
  city: string;
  age: number;
}

export interface ITableData extends Array<IUserData> {}

@Injectable()
export class DataTablesService {
  dataUrl = 'assets/data-tables.json';

  constructor(private http: HttpClient) {}

  async getData() {
    return await this.http.get<ITableData>(this.dataUrl)
      .toPromise(
        //retry(3), // retry a failed request up to 3 times
        //catchError(this.handleError), // then handle the error
      );
  }
  

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}